import React, { Component } from 'react'

import ReactMarkdown from "react-markdown"

import {Link} from 'gatsby'
import BackgroundImage from 'gatsby-background-image'



class UpdateGrid extends Component {
  constructor(props) {
    super(props)


    this.returnImage = this.returnImage.bind(this)

    this.layoutContents = React.createRef()

  }


  returnImage(image){

    return ([
image,
`linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.8))`
].reverse()
)

  }

  render() {




    return (

                                <li class="slice__item list__item row__item row__item--span-1">

                                                                        <div class="item itemEnlarge item--forecast">
                                                                            <div class="item__container" style={{backgroundColor:this.props.MainColour ,borderColor:this.props.MainColour}}>
                                                                                <div class="item__media">

                                                                                </div>
                                                                                <div class="item__content">
                                                                                    <div class="item__header">
                                                                                        <h3 class="item__title" style={{color:this.props.textColor}}>
                                                                                        <Link class="item__link" style={{color:this.props.textColor}}
                                                                                            to={`update/${this.props.data.slug}`}
                                                                                        >  {this.props.data.title}
                                                                                        </Link>

                                                                                        </h3>
                                                                                    </div>
                                                                                    <div class="item__teaser" style={{color:this.props.textColor}}>
                                                                                        {this.props.data.title}
                                                                                    </div>
                                                                                </div>
                                                                                <Link class="block-link-overlay"
                                                                                  to={`update/${this.props.data.slug}`}
                                                                                />
                                                                            </div>
                                                                        </div>

                                                                    </li>





    )


}
}

export default UpdateGrid;
